import Vue from 'vue'
import axios from 'axios'
import Vueaxios from 'vue-axios'
import Con from '../../static/config.json'

Vue.use(Vueaxios, axios)
const URL = Con.URL
export default {
  getCate (obj, header, success, error) {
    Vue.axios.post(URL + 'expense/categorys', obj, header).then(
      response => {
        success(response.data)
      },
      response => {
        error(response)
      }
    )
  },
  getSub (id, header, success, error) {
    Vue.axios.get(URL + 'expense/subcategorys/' + id, header).then(
      response => {
        success(response.data)
      },
      response => {
        error(response)
      }
    )
  },
  addExpen (obj, header, success, error) {
    Vue.axios.post(URL + 'expense', obj, header).then(
      response => {
        success(response.data)
      },
      response => {
        error(response)
      }
    )
  },
  updateExpen (obj, header, success, error) {
    Vue.axios.put(URL + 'expense', obj, header).then(
      response => {
        success(response.data)
      },
      response => {
        error(response)
      }
    )
  },
  addCateExpen (obj, header, success, error) {
    Vue.axios.post(URL + 'expense/category', obj, header).then(
      response => {
        success(response.data)
      },
      response => {
        error(response)
      }
    )
  },
  updateCateExpen (obj, header, success, error) {
    Vue.axios.put(URL + 'expense/category', obj, header).then(
      response => {
        success(response.data)
      },
      response => {
        error(response)
      }
    )
  },
  delCateExpen (id, header, success, error) {
    Vue.axios.delete(URL + 'expense/category/' + id, header).then(
      response => {
        success(response.data)
      },
      response => {
        error(response)
      }
    )
  },
  addSubExpen (obj, header, success, error) {
    Vue.axios.post(URL + 'expense/subcategory', obj, header).then(
      response => {
        success(response.data)
      },
      response => {
        error(response)
      }
    )
  },
  updateSubExpen (obj, header, success, error) {
    Vue.axios.put(URL + 'expense/subcategory', obj, header).then(
      response => {
        success(response.data)
      },
      response => {
        error(response)
      }
    )
  },
  delSubExpen (id, header, success, error) {
    Vue.axios.delete(URL + 'expense/subcategory/' + id, header).then(
      response => {
        success(response.data)
      },
      response => {
        error(response)
      }
    )
  },
  getExpen (id, header, success, error) {
    Vue.axios.get(URL + 'expense/' + id, header).then(
      response => {
        success(response.data)
      },
      response => {
        error(response)
      }
    )
  },
  searchExpenSub (obj, header, success, error) {
    Vue.axios.post(URL + 'expense/searchdetail', obj, header).then(
      response => {
        success(response.data)
      },
      response => {
        error(response)
      }
    )
  },
  getExpenAll (obj, header, success, error) {
    Vue.axios.post(URL + 'expense/search', obj, header).then(
      response => {
        success(response.data)
      },
      response => {
        error(response)
      }
    )
  },
  delExpen (id, header, success, error) {
    Vue.axios.delete(URL + 'expense/' + id, header).then(
      response => {
        success(response.data)
      },
      response => {
        error(response)
      }
    )
  }

}



// WEBPACK FOOTER //
// ./src/services/service_expend.js